import { IIdLabel } from "@mctypes/global.types";
import {
  usePutProjectByProjectIdIssueConnectedTasksUpdateOrderMutation,
  usePutProjectByProjectIdIssueUpdateDatesMutation,
} from "../../../../../../../openapi";
import { selectCurrentProjectId } from "../../../../../../global/globalSliceCommon";
import { useAppSelector } from "../../../../../../hooks";
import { selectSvarGantColumns, selectSvarGantItems, selectSvarGantZoomConfig } from "../issueGantSelectors";
import GanttWrapper from "./GantWrapper";
import SvarGantActionBar from "./SvarGantActionBar";

const taskTypes: IIdLabel[] = [
  { id: "opprettet", label: "Opprettet" },
  { id: "iprosess", label: "I prosess" },
  { id: "milestone", label: "Milestone" },
  { id: "påhold", label: "På hold" },
  { id: "fullført", label: "Fullført" },
  { id: "utgår", label: "Utgår" },
];

const SvarGantt: React.FC = () => {
  const projectId = useAppSelector(selectCurrentProjectId);
  const start = useAppSelector((state) => state.issueReducerNew.svarGant.startDate);
  const end = useAppSelector((state) => state.issueReducerNew.svarGant.endDate);
  const zoomConfig = useAppSelector(selectSvarGantZoomConfig);
  const columns = useAppSelector(selectSvarGantColumns);
  const gantItems = useAppSelector(selectSvarGantItems);

  const [updateIssueDates] = usePutProjectByProjectIdIssueUpdateDatesMutation();
  const [reorderConnectedTasks] = usePutProjectByProjectIdIssueConnectedTasksUpdateOrderMutation();

  return (
    <div className="hide-links hide-progress" style={{ height: "calc(100% - 80px)" }}>
      <SvarGantActionBar />
      <GanttWrapper
        start={start}
        end={end}
        zoom={zoomConfig}
        columns={columns}
        gantItems={gantItems}
        taskTypes={taskTypes}
        lengthUnit="day"
        onUpdateTask={(id, dates) =>
          updateIssueDates({
            projectId,
            body: {
              issueId: id,
              dates,
            },
          })
        }
        onReorderTasks={({ movedId, parentId, newOrder }) =>
          reorderConnectedTasks({
            projectId,
            body: {
              issueId: parentId, // if parent is the issue that owns tasks
              newOrder,
            },
          })
        }
      />
    </div>
  );
};

export default SvarGantt;
